import { Dropdown, IconButton, Text, Tiny } from 'components';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import logo from 'assets/icons/logo.svg';
import { clearUserInfo, userInfoSelector } from 'redux/slices/app/authSlice';
import { useNavigate } from 'react-router-dom';
import { removeStoragedItem } from 'utils/helper';

const Appbar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const profileOnClickHandle = () => {
    navigate(`/Profil`);
  };
  const exitOnClickHandle = () => {
    removeStoragedItem('clientToken');
    removeStoragedItem('userInfo');
    removeStoragedItem('clientUser');
    removeStoragedItem('clientUserRole');
    removeStoragedItem('clientRoleSettings');
    dispatch(clearUserInfo());
    navigate('/');
  };
  const [mobileMenuState, setMobileMenuState] = useState(false);

  const userInfo = useSelector(userInfoSelector);

  const dropdownItems = [
    {
      leftIcon: <i className="fa-sharp fa-solid fa-file-invoice"></i>,
      label: 'Hesabım',
      onClick: () => {
        navigate(`/Profil`);
      },
    },
    {
      leftIcon: <i className="fa-solid fa-arrow-right-from-bracket"></i>,
      label: 'Çıkış Yap',
      onClick: () => {
        removeStoragedItem('clientToken');
        dispatch(clearUserInfo());
        navigate('/');
      },
    },
  ];
  return (
    <div className={`w-full bg-sky-lighter`}>
      <nav className=" relative flex justify-between px-5 lg:px-1 h-20 max-h-20 items-center border-b-2 border-default-border">
        <img
          className="px-7 w-60 h-20 border-r border-default-border flex-none cursor-pointer"
          src={logo}
          alt="Solmaz Express Logo"
          onClick={() => {
            navigate('/landing');
          }}
        />
        <div className="hidden md:block ">
          <Text weight="bold" className="text-center text-primary ">
            {userInfo?.fullName}
          </Text>
          <div className="flex justify-center">
            <div onClick={profileOnClickHandle}>
              <Tiny className=" m-2 text-primary border-b-2 border-primary hover:border-primary-dark hover:cursor-pointer">
                Hesabım
              </Tiny>
            </div>
            <div onClick={exitOnClickHandle}>
              <Tiny className="m-2 text-primary border-b-2 border-primary hover:border-primary-dark hover:cursor-pointer">
                Çıkış
              </Tiny>
            </div>
          </div>
        </div>
        <IconButton
          className="inline-flex md:hidden items-center p-3 rounded-full hover:bg-sky-lightest"
          icon={
            mobileMenuState ? (
              <i className="fa-solid fa-xmark fa-lg" />
            ) : (
              <i className="fa-solid fa-bars fa-lg" />
            )
          }
          onClick={() => {
            setMobileMenuState(!mobileMenuState);
          }}
        />
      </nav>
      <div
        className={`${
          mobileMenuState ? 'flex' : 'hidden'
        } z-10 flex-col gap-y-2 bg-white absolute py-2 px-5 mt-2 h-96 overflow-y-auto border rounded border-default-border w-full`}
      >
        <div className="flex py-5 px-1 justify-around items-center gap-x-1">
          <IconButton
            className="inline-flex items-center p-1.5 lg:p-3 rounded-full hover:bg-sky-lightest"
            icon={<i className="fa-solid fa-grip fa-lg"></i>}
            onClick={() => {
              console.log('Icon Button Clicked.');
            }}
          />
          <IconButton
            className="inline-flex items-center p-1.5 lg:p-3 rounded-full hover:bg-sky-lightest"
            icon={<i className="fa-solid fa-file-lines fa-lg"></i>}
            onClick={() => {
              console.log('Icon Button Clicked.');
            }}
          />
          <IconButton
            className="inline-flex items-center p-1.5 lg:p-3 rounded-full hover:bg-sky-lightest"
            icon={<i className="fa-solid fa-envelopes-bulk fa-lg"></i>}
            onClick={() => {
              console.log('Icon Button Clicked.');
            }}
          />
          <IconButton
            className="inline-flex items-center p-3 rounded-full hover:bg-sky-lightest"
            icon={<i className="fa-solid fa-bell fa-lg" />}
            onClick={() => {
              console.log('Icon Button Clicked.');
            }}
          />
        </div>

        <Dropdown
          className="z-20 lg:px-2 w-full shrink-0"
          dropdownBarClassName="border-none"
          items={dropdownItems}
          dropdownBarLeftIcon={
            <div className="w-10 h-10 rounded-full bg-ink-lighter" />
          }
          dropdownBarText={userInfo?.fullName || ''}
        />
      </div>
    </div>
  );
};

export default Appbar;
